import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { CreateProfileRequest } from '@cash-web/shared-util-protos/squareup/cash/janus/api/AccountholderProfile.pb'
import { CreateProfileResponse } from '@cash-web/shared-util-protos/squareup/cash/janus/api/AccountholderProfile.pb'

export const createProfile = (request: CreateProfileRequest, options?: CashRequestOptions) =>
  post<CreateProfileRequest, CreateProfileResponse>('/2.0/cash/create-profile', request, {
    ...options,
    rejectOnError: true,
  })
